module.exports = __webpack_public_path__ + "7ecc7182ef23a10f52180fb56ba20a84.svg";